import { historyPush, historyReplace } from '../../services/History';
import { quizDetailsActionTypes } from './Constants';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { processRequest } from '../../services/Api';
import * as errorHandlerActions from '../../components/errorHandler/Actions';
import * as quizDetailsActions from './Actions';

export default function* () {
	yield all([
		takeLatest(quizDetailsActionTypes.GET_QUIZ_DETAILS_REQUEST, handleGetQuizDetailsRequest),
		takeLatest(quizDetailsActionTypes.DELETE_USER_QUIZ_REQUEST, handleDeleteQuizRequest),
		takeLatest(quizDetailsActionTypes.DUPLICATE_USER_QUIZ_REQUEST, handleDuplicateQuizRequest),
	]);
}

export function* handleGetQuizDetailsRequest({ payload }) {
	try {
		const { data } = payload || {};
		const { id } = data || {};

		const { data: respData } = yield call(processRequest, `public/user_quizzes/${id}`);

		yield put(
			quizDetailsActions.getQuizDetailsSuccess({
				...respData.user_quiz,
				no_index: respData.no_index,
			}),
		);
	} catch (e) {
		yield put(quizDetailsActions.getQuizDetailsError());
		yield put(errorHandlerActions.handleError(e));
	}
}

export function* handleDuplicateQuizRequest({ payload }) {
	try {
		const { data } = payload || {};
		const { id } = data || {};

		const { data: respData } = yield call(
			processRequest,
			`user_quizzes/${id}/duplicate`,
			'POST',
			{
				quiz_id: id,
			},
		);

		yield put(quizDetailsActions.duplicateQuizSuccess());
		yield call(historyPush, `/edit-quiz/${respData?.user_quiz?.id}`);
	} catch (e) {
		yield put(quizDetailsActions.duplicateQuizError());
		yield put(errorHandlerActions.handleError(e, 'notification'));
	}
}

export function* handleDeleteQuizRequest({ payload }) {
	try {
		const { data } = payload || {};
		const { id } = data || {};

		yield call(processRequest, `user_quizzes/${id}`, 'DELETE', { quiz_id: id });

		yield put(quizDetailsActions.deleteQuizSuccess());
		yield call(historyReplace, '/');
	} catch (e) {
		yield put(quizDetailsActions.deleteQuizError());
		yield put(errorHandlerActions.handleError(e));
	}
}
